<div class="formfield">
  <div class="">
    <label for="issuerList" class="nes-my-3">
      <nes-text color="blue" weight="bold">
        {{ "AGREEMENT.INPUT.ISSUER.LABEL" | translate }}
      </nes-text>
    </label>
    <select
      [cypress]="'issuer'"
      (ngModelChange)="selected.emit($event)"
      [(ngModel)]="selectedIssuerId"
      class="select nes-w-full nes-mr-0 xl:nes-mr-10"
      id="issuerList"
    >
      <option value="0" disabled>
        {{ "AGREEMENT.INPUT.ISSUER.DROPDOWN.CHOOSE" | translate }}
      </option>
      <option *ngFor="let issuer of issuers" [value]="issuer.id">
        {{ issuer.displayName }}
      </option>
    </select>
  </div>
  <div *ngIf="issuerRequiredError">
    <ng-container>
      <nes-error-message>
        {{ "AGREEMENT.INPUT.ISSUER.ERROR_REQUIRED" | translate }}
      </nes-error-message>
    </ng-container>
  </div>
</div>
